<section class="cards-list">
  <!-- suppliers list -->
  <section class="cards-list__suppliers">
    @if (suppliersList && !isLoading) {
      @if (allSuppliersCount > 0) {
        <ul class="suppliers-list">
          @for (supplier of suppliersList; track supplier._id) {
            <pwj-supplier-card
              [supplierCardData]="supplier"></pwj-supplier-card>
          }
        </ul>
      } @else {
        <div>
          <!-- no content component -->
          <pwj-no-content message="industries.noIndustries"></pwj-no-content>
        </div>
      }
    } @else {
      <!-- skeletons -->
      <div>
        <pwj-supplier-card-skeleton
          [count]="12"
          containerClasses="flex flex-col gap-24 mt-10"></pwj-supplier-card-skeleton>
      </div>
    }
  </section>

  <!-- pagination -->
  @if (allSuppliersCount) {
    <div>
      <pwj-pagination
        [dataCount]="allSuppliersCount"
        [perPage]="12"></pwj-pagination>
    </div>
  }
</section>
